import React from 'react';
import Modal from '../../../Overlays/Modal';
import TextButton from '../../TextButton';
import Button from '../../Button';
import * as styles from './style.module.css';
const FilterModalMenuContent = ({ menuHeading, menuSelectButtonLabel, menuClearButtonLabel, menuDoneButtonLabel, clearable = false, onMenuSelectButtonClick, onDone, onClear, children, }) => {
    const headerProps = {
        id: 'modal-filter-menu-header',
        headerText: menuHeading,
        ...(menuSelectButtonLabel && {
            headerAction: (React.createElement(TextButton, { buttonType: "inline", text: menuSelectButtonLabel, onClick: onMenuSelectButtonClick, sidePadding: false })),
        }),
    };
    const footerActions = [
        React.createElement(Button, { key: "doneButton", buttonType: "secondary1", text: menuDoneButtonLabel, onClick: onDone, fullWidth: false, size: "medium", className: styles.doneButton }),
    ];
    if (menuClearButtonLabel) {
        footerActions.unshift(React.createElement(TextButton, { key: "clearButton", buttonType: "inline", text: menuClearButtonLabel, onClick: onClear, disabled: !clearable, sidePadding: false, className: styles.clearButton }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal.Header, { ...headerProps }),
        React.createElement(Modal.Content, null, children),
        React.createElement(Modal.Footer, { mobileModalFooterDirection: "horizontal", className: styles.footer, footerActions: footerActions })));
};
export default FilterModalMenuContent;
//# sourceMappingURL=index.js.map